import styled from 'styled-components'

export const ContainerHtmlEditor = styled.div`
  .ql-editor {
    min-height: 100px;
  }
`
